import Color from "color";
import { ColorVariant } from "@/constants/theme";
import { useGetHEXColorByColorVariant } from "@/hooks/useGetHEXColorByColorVariant";

export default function useCreateRGBAColorFromColorVariant(
  colorVariant: ColorVariant,
  alpha: number,
) {
  const hex = useGetHEXColorByColorVariant(colorVariant);

  if (!hex || colorVariant === ColorVariant.Default) {
    return "";
  }

  return Color(hex).alpha(alpha).string();
}
